<template>
  <d-list-group>
    <d-list-group-item>
      <div
        v-if="activeDiscount"
        class="mb-4">
        <p class="h6">Aktywna bonifikata:</p>
        <strong>{{ activeDiscount.discount_name }}</strong>
        <d-button
          class="ml-5"
          theme="warning"
          @click.prevent="deactivateDiscount()">
          Wycofaj bonifikatę
        </d-button>
      </div>

      <table
        class="table mb-0 responsive-table"
        style="border: 1px #dee2e6 solid;table-layout: fixed;">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Kwota pożyczki (w tym prowizja)</th>
            <th scope="col" class="border-0">Kwota pożyczki dla klienta</th>
            <th scope="col" class="border-0">Prowizja</th>
            <th scope="col" class="border-0">Koszty dodatkowe</th>
            <th scope="col" class="border-0 text-center">Odsetki umowne</th>
            <th scope="col" class="border-0 text-right">Odsetki karne</th>
            <th scope="col" class="border-0 text-right">Kwota końcowa</th>
            <th scope="col" class="border-0 text-center" v-if="!isDraft">Zamknięcie umowy</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <dt>Kwota pożyczki (w tym prowizja)</dt>
              <dd>{{ toNumber(schedule.loan_amount + schedule.final_provision) }} zł</dd>
            </td>
            <td>
              <dt>Kwota pożyczki dla klienta</dt>
              <dd>{{ toNumber(schedule.loan_amount) }} zł</dd>
            </td>
            <td>
              <dt>Prowizja</dt>
              <dd>
                <template v-if="isDraft">
                  {{ toNumber(schedule.installment_sum) }} zł
                </template>
                <template v-else>
                  {{ toNumber(schedule.final_provision) }} zł
                </template>
              </dd>
            </td>
            <td>
              <dt>Koszty dodatkowe</dt>
              <dd>
                <template v-if="isDraft">
                  {{ toNumber(draftAdditionalCosts) }}zł
                </template>
                <template v-else>
                  {{ toNumber(schedule.additional_costs) }} zł
                </template>
              </dd>
            </td>
            <td class="text-center">
              <dt>Odsetki</dt>
              <dd>
                <template v-if="isDraft">
                  {{ toNumber(draftInterestsSum) }} zł
                </template>
                <template v-else>
                  {{ toNumber(schedule.interest_sum) }} zł
                </template>
                <br>
                <small>{{ toNumber(schedule.interest_rate) }} %</small>
              </dd>
            </td>
            <td class="text-right">
              <dt>Odsetki karne</dt>
              <dd>{{ toNumber(schedule.interest_penalty_sum) }} zł</dd>
            </td>
            <td class="text-right">
              <dt>Kwota końcowa</dt>
              <dd>
                <template v-if="isDraft">
                  {{ toNumber(draftLoanFinalSum) }} zł
                  <br>
                  <button
                    @click.prevent="$bus.$emit(
                      'view-details',
                      'details_to_finish_credit_under_contract',
                      draftLoanFinalSum,
                      'Kwota końcowa',
                      false
                    )"
                    type="button"
                    class="btn btn-link px-0">
                    pokaż szczegóły
                  </button>
                </template>
                <template v-else>
                  {{ toNumber(schedule.loan_final_sum) }} zł
                  <br>
                  <button
                    @click.prevent="$bus.$emit(
                      'view-details',
                      'details_to_finish_credit_under_contract',
                      schedule.loan_final_sum,
                      'Kwota końcowa',
                      false
                    )"
                    type="button"
                    class="btn btn-link px-0">
                    pokaż szczegóły
                  </button>
                </template>
              </dd>
            </td>
            <td
              v-if="!isDraft"
              class="text-center">
              <dt>Zamknięcie umowy</dt>
              <dd v-if="!schedule.close_date">
                <div class="button-date-wrapper">
                <ss-date
                  @picked="closeContract(false)"
                  type="text"
                  name="close-date"
                  v-model="closeDate"
                  placeholder=""
                  :trigger-with-button="true"
                  trigger-button-label="Zamknij umowę"/>
                </div>
              </dd>
              <dd v-else>
                <span class="text-success">{{ schedule.close_date }}</span>
                <br>
                <d-button
                  class="mt-2"
                  theme="warning"
                  size="sm"
                  @click.prevent="undoCloseContract()">
                  Cofnij zamknięcie
                </d-button>
              </dd>
            </td>
          </tr>
        </tbody>
      </table>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import SsDate from '@/components/common/SsDate';

export default {
  name: 'ContractLoanSummary',
  components: {
    SsDate,
  },
  props: {
    isDraft: {
      required: true,
      type: Boolean,
    },
    schedule: {
      required: true,
      type: Object,
    },
  },
  computed: {
    activeDiscount() {
      return this.schedule.discounts.find(item => item.discount_active);
    },
    draftAdditionalCosts() {
      return Number(this.schedule.default_reminder_price);
    },
    draftInterestsSum() {
      return this.schedule.installments.reduce((sum, item) => sum + item.interest, 0);
    },
    draftLoanFinalSum() {
      return Number(this.schedule.loan_amount) + Number(this.schedule.installment_sum) + Number(this.draftAdditionalCosts) + Number(this.draftInterestsSum) + Number(this.schedule.interest_penalty_sum);
    },
  },
  data() {
    return {
      closeDate: '',
    };
  },
  mounted() {
  },
  methods: {
    closeContract(approved) {
      const self = this;

      setTimeout(() => {
        axios.post('api/schedules/close-contract', {
          id: self.schedule.id,
          close_date: self.closeDate,
          approved,
        }).then((response) => {
          const resp = response.data;
          if (resp.success === 0) {
            let information = `Na dzień <strong>${self.closeDate}</strong> suma zadłużenia <br />wynosiłaby <strong>${self.toNumber(resp.close_amount).replace('-', '')} zł</strong>, czy jesteś pewny, <br />że chcesz zamknąć umowę?`;

            if (resp.close_amount < 0) {
              information = `Na dzień <strong>${self.closeDate}</strong> suma nadpłaty <br />wynosiłaby <strong>${self.toNumber(resp.close_amount).replace('-', '')} zł</strong>, czy jesteś pewny, <br />że chcesz zamknąć umowę?`;
            }
            Vue.swal({
              title: 'Uwaga',
              html: information,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Tak',
              cancelButtonText: 'Nie',
              buttonsStyling: true,
            }).then((submit) => {
              if (submit.value) {
                self.closeContract(true);
              }
            });
          } else if (resp.success === 1) {
            Vue.swal({
              type: 'success',
              title: 'Umowa została zamknięta.',
              showConfirmButton: true,
            }).then(() => {
              this.showPaymentGuaranteesInfo();
              this.$bus.$emit('reload-contract');
            });
          }
        }).catch((error) => {
          Vue.swal({
            type: 'warning',
            title: 'Wystąpił błąd',
            text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
            showConfirmButton: true,
          });
        });
      }, 100);
    },
    undoCloseContract() {
      const self = this;

      Vue.swal({
        title: 'Potwierdzenie',
        html: 'Czy na pewno chcesz cofnąć zamknięcie tej umowy?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak, cofnij',
        cancelButtonText: 'Anuluj',
        buttonsStyling: true,
      }).then((submit) => {
        if (submit.value) {
          axios.post('api/schedules/undo-close-contract', {
            id: self.schedule.id,
          }).then((response) => {
            const resp = response.data;
            if (resp.success === 1) {
              Vue.swal({
                type: 'success',
                title: 'Zamknięcie umowy zostało cofnięte.',
                showConfirmButton: true,
              }).then(() => {
                self.$bus.$emit('reload-contract');
              });
            }
          }).catch((error) => {
            Vue.swal({
              type: 'warning',
              title: 'Wystąpił błąd',
              text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
              showConfirmButton: true,
            });
          });
        }
      });
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
    deactivateDiscount() {
      this.$bus.$emit('contract-schedule-deactivate-discount');
    },
    showPaymentGuaranteesInfo() {
      if (!this.schedule.payment_guarantees_number) {
        return;
      }

      Vue.swal({
        title: 'Uwaga',
        html: 'Umowa posiada hipoteki / zastawy do zwolnienia.',
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK',
        buttonsStyling: true,
      });
    },
  },
};
</script>
